import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import { Form, Button, InputGroup, FormControl, Table } from "react-bootstrap";
import { connect } from "react-redux";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import moment from "moment";

const SCREEN_NAME = "REOPEN_ACCOUNT_SCREEN";

class ReopenAccountInner extends AppComponent {
  state = {
    recurringPeriod: "6",
    reopeningDate: new Date(),
    endingDate: this.calcDate({ month: 6, day: -1, date: new Date() }),
    returningDate: this.calcDate({ month: 6, day: 4, date: new Date() }),
  };

  formRef = React.createRef(null);

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      const accountType = this.props.account.accountType;
      let payload =
        accountType === "loan"
          ? {}
          : accountType === "deposit"
            ? _.pick(this.state, ["endingDate", "returningDate"])
            : {};

      if (
        payload.endingDate &&
        new Date().getTime() > new Date(payload.endingDate).getTime()
      ) {
        throw new Error("Ending Date must be greater than reopening date");
      }

      if (
        payload.returningDate &&
        payload.endingDate &&
        new Date(payload.endingDate).getTime() >
          new Date(payload.returningDate).getTime()
      ) {
        throw new Error("Returning Date must be greater than ending date");
      }

      this.setAsyncState({ loading: true, error: null });

      await api.put(`v1/account/${this.props.account._id}/reopen`, payload);

      this.setAsyncState({ loading: false });
      this.props.onSubmit();
    } catch (e) {
      console.error(e);
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  calcDate({ month, day, date }) {
    let monthUpdated = new Date(
      new Date(new Date(date).setHours(0, 0, 0, 0)).setMonth(
        new Date(date).getMonth() + parseInt(month || 0),
      ),
    );

    let dayUpdated = new Date(
      new Date(monthUpdated).getTime() + 1000 * 60 * 60 * 24 * (day || 0),
    );

    return dayUpdated;
  }

  renderForm() {
    if (!this.props.account) return null;

    const {
      props: {
        renderModal = false,
        account: { accountType, customer, shortId },
      },
      state: {
        error,
        recurringPeriod,
        reopeningDate,
        endingDate,
        returningDate,
      },
    } = this;

    const isEditing = !!this.props.account?._id;

    return (
      <>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
          ref={this.formRef}
        >
          <Form.Group>
            <div>
              <Form.Label>Account Details</Form.Label>
              <Table striped bordered hover size="sm">
                <tbody>
                  <tr>
                    <th>Account ID</th>
                    <td>{shortId}</td>
                  </tr>
                  <tr>
                    <th>Customer Name</th>
                    <td>{getFullName(customer)}</td>
                  </tr>
                  <tr>
                    <th>Account Type</th>
                    <td>{_.startCase(accountType)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Reopening Date</Form.Label>
            <Form.Control
              type="date"
              defaultValue={moment(new Date(reopeningDate).getTime()).format(
                "YYYY-MM-DD",
              )}
              disabled
              required
              name="endingDate"
            />
          </Form.Group>

          {accountType === "deposit" ? (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Period</Form.Label>
                <InputGroup className="mb-3">
                  <FormControl
                    type={"number"}
                    placeholder="no of months"
                    value={recurringPeriod}
                    onChange={({ target: { value } }) => {
                      const endingDate = this.calcDate({
                        month: value,
                        day: -1,
                        date: reopeningDate,
                      });
                      const returningDate = this.calcDate({
                        month: value,
                        day: 4,
                        date: reopeningDate,
                      });
                      this.setAsyncState({
                        recurringPeriod: value,
                        endingDate,
                        returningDate,
                      });
                    }}
                    required
                    name="period"
                    disabled={!reopeningDate}
                  />
                  <InputGroup.Text id="basic-addon1">Months</InputGroup.Text>
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Ending Date</Form.Label>
                <Form.Control
                  type="date"
                  value={moment(new Date(endingDate).getTime()).format(
                    "YYYY-MM-DD",
                  )}
                  onChange={(e) => {
                    const endingDate = new Date(
                      new Date(e.target.value).setHours(0, 0, 0, 0),
                    );

                    this.setAsyncState({
                      endingDate,
                    });
                  }}
                  required
                  name="endingDate"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Returning Date</Form.Label>
                <Form.Control
                  type="date"
                  value={
                    returningDate
                      ? moment(new Date(returningDate).getTime()).format(
                          "YYYY-MM-DD",
                        )
                      : ""
                  }
                  onChange={(e) => {
                    const returningDate = new Date(
                      new Date(e.target.value).setHours(0, 0, 0, 0),
                    );

                    this.setAsyncState({
                      returningDate,
                    });
                  }}
                  name="returningDate"
                  required
                />
              </Form.Group>
            </>
          ) : null}

          <div className="errormsg">{error}</div>

          {renderModal ? null : (
            <Button variant="primary" type="submit">
              Submit
            </Button>
          )}
        </Form>
      </>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: "Confirm Account Reopen",
          submitBtnText: "Reopen Account",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const ReopenAccount = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReopenAccountInner);

export default ReopenAccount;
